import React from "react";
import {View, StyleSheet, TouchableOpacity} from "react-native";
import {styleVars} from "../../app-style-vars";
import PtRadioButtons from "../core/pt-radio-buttons";
import {getTranslation} from "../../helpers/getTranslation";
import PtDateTimeRange from "../core/pt-date-time-picker/pt-date-time-range";
import PtText from "../core/pt-text/pt-text";


const tomorrow = new Date().setDate(new Date().getDate() + 1);
const yearAgo = new Date(tomorrow).setFullYear(new Date(tomorrow).getFullYear() - 1);

export default function PtDuePaymentsFilter(props:any) {

  /** labels */
  const duePaymentStatusTitle = props.filtersOptions?.duePaymentStatus?.title || 'Status';
  const duePaymentTypeTitle = props.filtersOptions?.duePaymentType?.title || 'Entry type';
  /** data */
  const duePaymentStatusChoices = props.filtersOptions?.duePaymentStatus?.choices || [];
  const duePaymentTypeChoices = props.filtersOptions?.duePaymentType?.choices || [];
  const duePaymentDateRangeTitle = props.filtersOptions?.dueDate?.title || 'By due date';
  const startDateLabel = props.filtersOptions?.dueDate?.startDateLabel || 'From date';
  const endDateLabel = props.filtersOptions?.dueDate?.endDateLabel || 'To date';
  const startDate = props.requestParams.dueDateFrom;
  const endDate = props.requestParams.dueDate;
  const minDate = props.filtersOptions?.dueDate?.minDate || yearAgo;
  const maxDate = props.filtersOptions?.dueDate?.maxDate;

  /** settings */
  const filtersContainerStyle = props.show ? styles.filtersContainerShown : null;

  /** pass through handlers */
  const duePaymentStatusFilterChangedHandler = props.duePaymentStatusFilterChangedHandler;
  const duePaymentTypeFilterChangedHandler = props.duePaymentTypeFilterChangedHandler;
  const startDateChangedHandler = props.startDateChangedHandler;
  const endDateChangedHandler = props.endDateChangedHandler;

  const applyFilters = () => {
    props.applyFiltersHandler();
  }

  return (
    <View style={[styles.filtersContainer, filtersContainerStyle]}>
      <View style={[styles.filtersWrapper]}>
        <View style={[styles.radioButtonsContainer]}>
          <PtRadioButtons
            title={duePaymentStatusTitle}
            buttons={duePaymentStatusChoices}
            requestParams={props.requestParams}
            initialValue = {props.requestParams.status}
            valueChangedHandler = {duePaymentStatusFilterChangedHandler}
          />
        </View>

        <View style={[styles.radioButtonsContainer]}>
          <PtRadioButtons
            title={duePaymentTypeTitle}
            buttons={duePaymentTypeChoices}
            requestParams={props.requestParams}
            initialValue = {props.requestParams.entryType}
            valueChangedHandler = {duePaymentTypeFilterChangedHandler}
          />
        </View>

        <View style={[styles.datePickerContainer]}>
          <PtDateTimeRange
            title={duePaymentDateRangeTitle}
            dateFromLabel={startDateLabel}
            dateToLabel={endDateLabel}
            requestParams={props.requestParams}
            startDate={props.requestParams.dueDateFrom || startDate}
            endDate={props.requestParams.dueDate || endDate}
            minDate={minDate}
            maxDate={maxDate}
            startDateChangedHandler = {startDateChangedHandler}
            endDateChangedHandler = {endDateChangedHandler}
          />
        </View>
      </View>
      <View style={[styles.applyFiltersContainer]}>
        <TouchableOpacity onPress={() => applyFilters()}>
          <View style={[styles.applyFiltersButton]}>
            <PtText style={[styles.applyButtonText]}>{getTranslation('due.payments.apply.button.label')}</PtText>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  filtersContainer: {
    paddingVertical: styleVars.rem(.5),
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    display: 'none',
    zIndex: 2
  },
  filtersContainerShown: {
    display: 'flex',
  },
  filtersWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    zIndex: 2
  },
  radioButtonsContainer: {
    minWidth: 300
  },
  datePickerContainer: {
    minWidth: 300
  },
  applyFiltersContainer: {
    justifyContent: 'center',
    width: '100%',
    maxWidth: 300
  },
  applyFiltersButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: styleVars.boschDarkBlue,
    height: styleVars.rem(2.5),
    paddingHorizontal: styleVars.rem(1),
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 0,
  },
  applyButtonText: {
    color: styleVars.boschDarkBlue
  }
})